<template>
    <div>
      <div class="row">
        <div class="col-12">
          <h4>Edit User</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-8">
          <form>
            <div class="form-group">
              <label for="txtUsername">Username</label>
              <input type="text" class="form-control" id="txtUsername" v-model="user.username">
            </div>
            <div class="form-group">
              <label for="txtPassword">Password</label>
              <input type="password" class="form-control" id="txtPassword" v-model="user.password">
            </div>
            <div class="form-group">
              <label for="ddlUserGroup">Group</label>
              <select class="form-control" id="ddlUserGroup" v-model="user.group_id">
                <option v-for="group in groups" :key="group.group_id" v-bind:value="group.group_id">
                  {{ group.name }}
                </option>
              </select>
            </div>
            <button type="button" class="btn btn-hub-primary" @click="submit()" >Submit</button>
            <router-link :to="{ name: 'AdminUsersIndex' }" class="btn btn-secondary">Cancel</router-link>
          </form>
        </div>
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'users-edit',
  props: [
    'user_id'
  ],
  computed: {
    ...mapGetters({
      user: 'singleUser',
      groups: 'allGroups'
    })
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getGroups')
    this.$store.dispatch('getUser', this.user_id)
  },
  methods: {
    submit () {
      this.$store.dispatch('addEditUser', this.user)
    }
  }
}
</script>

<style scoped>

</style>
